module.exports = __webpack_public_path__ + "img/3.f053e930.png";